import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { LiveMarketEvent, liveMarketApi } from "src/api/liveMarketApi";
import { getLiveMarketMenuConfig } from "src/config/live-market";

const LiveMarketGameEventsPage = () => {
  const { casinoType, gameId } = useParams<{ casinoType: string; gameId: string }>();

  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState<LiveMarketEvent[]>([]);
  const [error, setError] = useState("");

  const menuConfig = useMemo(() => getLiveMarketMenuConfig(casinoType), [casinoType]);
  const fallbackGroupId = process.env.REACT_APP_LIVE_MARKET_GROUP_ID?.trim();
  const effectiveGroupId = menuConfig?.groupId?.trim() || (casinoType === "group" ? fallbackGroupId : undefined);

  useEffect(() => {
    if (!menuConfig && casinoType !== "group") {
      setError("Invalid LIVE Market menu.");
      setEvents([]);
      return;
    }

    if (!effectiveGroupId) {
      setError(`Group ID is missing for ${menuConfig?.title || "Live Market"}.`);
      setEvents([]);
      return;
    }

    let mounted = true;
    setLoading(true);
    setError("");

    liveMarketApi
      .fetchBusinessGroupGameEvents(effectiveGroupId)
      .then((response) => {
        if (!mounted) return;
        setEvents(Array.isArray(response) ? response : []);
      })
      .catch(() => {
        if (!mounted) return;
        setEvents([]);
        setError("Unable to load LIVE Market games.");
      })
      .finally(() => {
        if (!mounted) return;
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [menuConfig, effectiveGroupId, casinoType]);

  const filteredEvents = useMemo(() => {
    if (!gameId) return [];
    return events.filter((event) => event.game_id === gameId || event.game_name === gameId);
  }, [events, gameId]);

  return (
    <div className="main-content">
      <div className="page-content">
        {loading && <div className="alert alert-info">Loading games...</div>}
        {!loading && error && <div className="alert alert-warning">{error}</div>}

        {!loading && !error && (
          <div>
            <div className="col-md-12 featured-box">
              <div>
                <div className="row diamond-casino-container mt-3">
                  {filteredEvents.map((event) => {
                    const eventImage = event.game_thumbnail2 || event.game_thumbnail;
                    const providerEventId = event.provider_event_id || event.game_event_id;
                    return (
                      <div className="casino-box" key={event.game_event_id}>
                        <Link
                          to={`/casinoanalysisuser/${providerEventId}`}
                          state={{
                            providerName: event.provider_name,
                            providerGameId: event.provider_game_id,
                            eventName: event.event_name,
                            providerType: event.provider_type,
                          }}
                          className=""
                        >
                          <div className="casino-icons">
                            {eventImage ? (
                              <img
                                src={eventImage}
                                alt={event.event_name}
                                className="img-fluid"
                                style={{ width: "100%", height: "100%", objectFit: "fill" }}
                              />
                            ) : null}
                          </div>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveMarketGameEventsPage;
